import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { CoverCreditCardFeesSelector } from '~/components/agreement-controllers/CoverCreditCardFeesSelector';
import { useStore } from '~/contexts';
import { useLocaleKeys } from '~/i18n';
import EditableTableCell from '../EditableTableCell/EditableTableCell';
import { getUICompanyName } from '../EditDraftsTable.utils';
export const GetCreditCardProcessingFeesCellTID = (parentTestId)=>getTestIds({
        parentTestId,
        deprecatedTestIds: {
            CreditCardProcessingFeesCellTID: {
                EditCell: (index)=>index != null ? "edit-credit-card-processing-fees-".concat(index) : '',
                Value: (index)=>index != null ? "credit-card-processing-fees-".concat(index) : '',
                Modal: 'edit-credit-card-processing-fees-modal'
            }
        }
    });
export default function CreditCardProcessingFeesCell(param) {
    let { draft, index, contact, onOpenModal, isDisabled, disabledTooltip } = param;
    const { t: draftCellsTexts } = useLocaleKeys('pages.draftsDashboard.editTable.draftCells');
    const { t: editTableTexts } = useLocaleKeys('pages.draftsDashboard.editTable');
    const { CreditCardProcessingFeesCellTID } = useMemo(()=>GetCreditCardProcessingFeesCellTID(), []);
    const draftLabel = getUICompanyName(draft, contact, editTableTexts.anchorSample());
    const userInfo = useStore((state)=>state.userInfo);
    const worksAt = userInfo === null || userInfo === void 0 ? void 0 : userInfo.business();
    const isPaidByClient = !draft.coverCreditCardFees();
    const onClick = ()=>onOpenModal({
            renderContent: (param)=>{
                let { draft, setDraft } = param;
                return {
                    title: draftCellsTexts.cardProcessingFees(),
                    testId: CreditCardProcessingFeesCellTID.Modal(),
                    onSubmit: (defaultBehavior)=>{
                        defaultBehavior();
                    },
                    content: /*#__PURE__*/ _jsx(CoverCreditCardFeesSelector, {
                        value: draft.coverCreditCardFees(),
                        onChange: (value)=>setDraft(draft.setCoverCreditCardFees(value)),
                        vendorBusinessName: worksAt === null || worksAt === void 0 ? void 0 : worksAt.name,
                        clientBusinessName: contact === null || contact === void 0 ? void 0 : contact.companyName(),
                        testId: CreditCardProcessingFeesCellTID.Modal()
                    })
                };
            }
        });
    return /*#__PURE__*/ _jsx(EditableTableCell, {
        testId: CreditCardProcessingFeesCellTID.EditCell(index),
        onClick: onClick,
        isDisabled: isDisabled,
        disabledTooltip: disabledTooltip,
        children: /*#__PURE__*/ _jsx(Typography, {
            testId: CreditCardProcessingFeesCellTID.Value(index),
            children: isPaidByClient ? "Paid by ".concat(draftLabel || 'the client') : "Paid by ".concat((worksAt === null || worksAt === void 0 ? void 0 : worksAt.name) || 'the service provider')
        })
    });
}
